export const en = {
  "person.mute": "Mute for me",
  "person.volume": "Volume for me",
  "person.muted": "Muted for me",
  "person.changed": "Volume for me: {volume}%",
  "person.controls": "Options for {name}",
  "person.voiceSettings": "Voice settings",
  "audio.listen": "Hear yourself",
  "audio.stopListening": "Stop test",
  "audio.listenHint": "3 s recording. Use headphones.",
  "audio.recording": "Speak now…",
  "audio.preparing": "Preparing…",
  "audio.previewRetry": "Retry microphone preview",
  "audio.playing": "Playing…",
  "audio.listenInCall": "Leave voice to test your microphone.",
  "audio.listenMuted": "Unmute to test your microphone.",
  "notify.scopeTitle": "Notification settings",
  "notify.scopeHint": "Choose which messages can alert you. Messages stay in chat.",
  "notify.mode.all": "All messages",
  "notify.mode.mentions": "Mentions only",
  "notify.mode.none": "None",
  "notify.mode.default": "Use general settings",
  "notify.mode.server": "Use server settings",
  "notify.channelSettings": "Notifications for {name}",
  "desktop.loginApproval": "Allow Gwar to start",
  "desktop.loginSaved": "Saved startup at login",
  "desktop.loginRemoveHint": "Remove the saved entry. This macOS version can’t confirm whether Gwar will open.",
  "desktop.loginRemovedHint": "Saved startup removed. Enabling it here requires macOS 13 or later.",
  "desktop.loginSettings": "System Settings",
  "desktop.loginPending": "Startup not confirmed",
  "desktop.loginCheck": "Check again",
  "desktop.openAtLogin": "Open at login",
  "desktop.openAtLoginHint": "Open Gwar when you sign in to this computer.",
  "desktop.startMinimized": "Start minimized",
  "desktop.startMinimizedHint": "Keep the window minimized when Gwar starts.",
  "desktop.startupFailed": "Couldn’t read or save startup settings.",
  "connect.invitation": "Invitation",
  "connect.inviteDetails": "Invite details",
  "connect.inviteReviewHint": "Check the server address before joining. Its name and members are available after you connect.",
  "connect.joinServer": "Join {server}",
  "connect.openInApp": "Open in the desktop app",
  "connect.reviewFailed": "Couldn’t leave the current server. Try again.",
  "connect.reviewInvite": "Review invitation",
  "connect.leaveToReview": "Continuing disconnects you from your current server. You can review the invitation before choosing to join.",
  "connect.inviteName": "Name supplied by the inviter",
  "connect.inviteKey": "Server fingerprint",
  "desktop.retry": "Try again",

  "settings.sounds": "App sounds",
  "sounds.enabled": "Sound cues",
  "sounds.hint": "Quiet cues for what happens in Gwar.",
  "sounds.volume": "Cue volume",
  "sounds.deafenHint": "While deafened, only mute and deafen controls make a sound. Voice volume is separate.",
  "sounds.preview": "Play: {event}",
  "sounds.voice": "Voice channel",
  "sounds.controls": "Microphone and headphones",
  "sounds.connection": "Connection",
  "sounds.messages": "Messages",
  "sounds.screen": "Screen sharing",
  "sounds.selfJoin": "You join voice",
  "sounds.selfLeave": "You leave or disconnect",
  "sounds.peerJoin": "Someone joins your channel",
  "sounds.peerLeave": "Someone leaves your channel",
  "sounds.mute": "Microphone muted",
  "sounds.unmute": "Microphone unmuted",
  "sounds.deafen": "Headphones deafened",
  "sounds.undeafen": "Headphones undeafened",
  "sounds.connectionLost": "Voice connection lost",
  "sounds.reconnected": "Voice connection restored",
  "sounds.mention": "You are mentioned",
  "sounds.directMessage": "Direct message received",
  "sounds.shareStarted": "Someone starts sharing",
  "sounds.shareStopped": "Your share stops unexpectedly",

  "common.close": "Close",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.saved": "Saved",
  "common.create": "Create",
  "common.delete": "Delete",
  "common.copy": "Copy",

  "storage.newer.title": "Gwar cannot open its saved data",
  "storage.newer.body": "A newer version of Gwar saved data in this browser or app, and this version cannot read it. Nothing was changed. Reload the page or install the latest Gwar.",

  "nav.servers": "Servers",
  "nav.sections": "Sections",
  "nav.home": "Home",
  "nav.account": "Your profile",
  "nav.back": "Back",
  "nav.more": "More",
  "nav.profile": "Profile",
  "nav.toChannels": "Back to channels",

  "rail.label": "Saved servers",
  "rail.connect": "Connect",
  "rail.edit": "Edit",
  "rail.remove": "Remove",
  "rail.add": "Add a server",
  "group.move": "Move to group",
  "group.new": "New group…",
  "group.newTitle": "New group",
  "group.leave": "Take out of the group",
  "group.edit": "Edit group",
  "group.delete": "Delete group",
  "group.collapse": "Fold the group",
  "group.expand": "Unfold the group",
  "group.description": "Groups tidy up the server column. They are kept on this device.",
  "group.name": "Name",
  "group.color": "Colour",
  "group.colorN": "Colour {n}",

  "home.greeting": "Hi, {name}",
  "home.greetingAnon": "Hi",
  "home.connected": "Connected",
  "home.notConnected": "Not connected",
  "home.pickServer": "Pick a server to join",
  "home.notInVoice": "Not in a voice channel",
  "home.openServer": "Open the server",
  "home.connect": "Connect to a server",
  "home.saved": "Saved servers",
  "home.current": "Connected now",

  "overview.title": "Overview",
  "overview.onlineCount": "{count} online",
  "overview.voiceCount": "{count} in voice",
  "overview.joinNamed": "Join {name}",
  "overview.join": "Join",
  "overview.youAreHere": "You are here",
  "overview.voiceRooms": "Active voice rooms",
  "overview.nobodyTalks": "Nobody is talking right now.",
  "overview.online": "Online now",
  "overview.inRoom": "In voice: {name}",
  "overview.notInVoice": "Online",
  "overview.more": "and {count} more",
  "overview.noNews": "No messages yet.",
  "overview.attachment": "Attachment",
  "overview.unread": "Unread",
  "overview.allRead": "All caught up.",

  "connect.title": "Welcome",
  "connect.subtitle": "Join a server to talk and chat with your people.",
  "connect.address": "Server address",
  "connect.addressHint": "A hostname or IP, e.g. voice.example.com or 192.168.1.10:8790",
  "nickname.identityTitle": "Identity nickname",
  "nickname.globalHint": "Used on servers you join for the first time. On a server you already belong to, change your nickname in that server’s menu.",
  "nickname.change": "Change nickname",
  "nickname.serverHint": "This nickname belongs to this member on this server and is shared across their devices.",
  "nickname.invalid": "Enter a nickname containing 1 to 32 characters.",
  "member.profile": "Member profile",
  "member.viewProfile": "View profile",
  "member.uid": "Full user ID",
  "member.handleChanged": "@{handle} belonged to a different account before. Handles can move between accounts, so this may be someone else. If you know it is the same person (for example on a new account), accept it.",
  "member.acceptHandle": "Accept this account",
  "member.acceptNotSaved": "Not accepted: this browser did not let Gwar save it. Reload the page and try again.",
  "badge.connectAccount": "Gwar Connect account: @{handle}",
  "badge.handleChanged": "@{handle}: this handle belonged to a different account before",

  "connect.nickname": "Nickname",
  "connect.nicknamePlaceholder": "What should people call you?",
  "connect.password": "Server password",
  "connect.passwordHint": "{server} is password protected.",
  "connect.remember": "Remember this server",
  "connect.submit": "Connect",
  "connect.retrying": "Waiting for a connection. Trying again…",
  "connect.otherTab": "Gwar is open in another tab",
  "connect.here": "Use here",
  "connect.backToForm": "Back to connection form",
  "connect.connecting": "Connecting…",
  "connect.saved": "Saved servers",
  "connect.kind": "Server type",
  "connect.kindVc": "Gwar server",
  "connect.kindTs": "TeamSpeak server",
  "connect.tsWebOnly": "Browsers can't speak TeamSpeak's UDP protocol. Use the desktop app to join TeamSpeak servers.",
  "connect.tsAddressHint": "A hostname or IP, e.g. ts.example.com. The default port is 9987.",
  "connect.tsIdentity": "TeamSpeak identity",
  "connect.tsPassword": "Server password (optional)",
  "badge.teamspeak": "TeamSpeak",
  "badge.teamspeakShort": "TS",
  "addServer.tsPasswordHint": "Optional. Only needed if the TeamSpeak server is password protected.",
  "addServer.tsChannel": "Channel",
  "addServer.tsChannelHint": "Optional. The channel to land in on connecting, with its parents: Lobby/Games.",
  "addServer.tsChannelPlaceholder": "Lobby/Games",
  "addServer.tsChannelPassword": "Channel password",
  "addServer.tsChannelPasswordHint": "Optional. Saved like the server password.",
  "err.ts.desktopOnly": "TeamSpeak servers can only be used from the desktop app.",

  "close.kicked": "You were kicked from the server by {by}.",
  "close.kickedReason": "You were kicked from the server by {by}: {reason}",
  "close.replaced": "You signed in from another window or device, so this session was closed.",
  "close.lost": "The connection to the server was lost.",

  "addServer.title": "Add a server",
  "addServer.editTitle": "Edit server",
  "addServer.description": "Saved servers appear in the sidebar. Everything is stored only in this browser.",
  "addServer.name": "Display name",
  "addServer.nameHint": "Optional. Defaults to the server's own name.",
  "addServer.password": "Server password",
  "addServer.passwordHint": "Optional. Saved in this browser so you can reconnect with one click.",
  "addServer.saveConnect": "Save and connect",

  "settings.title": "Settings",
  "alpha.badge": "Alpha",
  "alpha.hint": "Gwar is in alpha: expect bugs and changes. Please report what goes wrong.",
  "report.open": "Report a bug",
  "update.downloading": "Downloading Gwar {version}…",
  "update.downloadingProgress": "Downloading Gwar {version}: {percent}%",
  "update.ready": "Gwar {version} is ready: click to restart and update",
  "update.installing": "Installing Gwar {version}…",
  "update.failed": "Could not update to Gwar {version}: {error}. Click to try again.",
  "update.confirmTitle": "Restart Gwar now?",
  "update.confirmBody": "Installing Gwar {version} restarts the app and stops screen sharing. Your voice call is briefly interrupted, then Gwar tries to rejoin it.",
  "update.confirm": "Restart and update",
  "version.copy": "Gwar {version}: click to copy",
  "version.copied": "Copied {version}",
  "report.title": "Report a bug",
  "report.description": "Tell us what went wrong. Gwar is in alpha, and every report helps.",
  "report.what": "What happened?",
  "report.placeholder": "What did you do, what did you expect, and what happened instead?",
  "report.addShot": "Add screenshot",
  "report.removeShot": "Remove screenshot",
  "report.shotHint": "Paste (Ctrl+V / ⌘V), drop or choose up to 5 images. Crop out anything private: screenshots may show your conversations.",
  "report.tooManyShots": "At most {max} screenshots.",
  "report.badShot": "That image cannot be attached (PNG, JPEG, WebP or GIF).",
  "report.diagnostics": "Include diagnostics",
  "report.diagnosticsHint": "App version, platform, connection and voice state, and the latest warnings and errors. No keys, passwords or messages.",
  "report.showDiagnostics": "Show what is sent",
  "report.hideDiagnostics": "Hide",
  "report.privacy": "Sent privately to the Gwar team (Gwar Connect), not published.",
  "report.privacyAccount": "Sent privately to the Gwar team (Gwar Connect) with your account @{handle}, not published.",
  "report.send": "Send report",
  "report.sent": "Thank you! Report #{id} was sent.",
  "report.failed": "The bug report was not sent: {error}",
  "settings.audio": "Voice",
  "settings.appearance": "Appearance",
  "settings.identity": "Identity",
  "settings.language": "Language",
  "settings.identityUnavailable": "Could not load your identity in this browser.",

  "audio.devices": "Devices",
  "audio.input": "Microphone",
  "audio.output": "Speakers",
  "audio.outputUnsupported": "This browser can only use the system default output.",
  "audio.systemDefault": "System default",
  "audio.masterVolume": "Output volume",
  "audio.inputMode": "Input mode",
  "audio.vad": "Voice activity",
  "audio.ptt": "Push to talk",
  "audio.vadHelp": "Your microphone transmits automatically when you speak.",
  "audio.automaticSensitivity": "Automatically determine input sensitivity",
  "audio.automaticSensitivityHint": "Turn off to set it yourself.",
  "audio.sensitivity": "Input sensitivity",
  "audio.previewEnable": "Enable microphone preview",
  "audio.pressKey": "Press a key…",
  "audio.pressPtt": "Press a key or mouse button…",
  "audio.pttDelay": "Release delay",
  "audio.pttDelayLabel": "Push-to-talk release delay",
  "audio.pttAllow": "Allow",
  "audio.pttDetails": "Push-to-talk details",
  "audio.pttStatus.ready": "Also works outside Gwar.",
  "audio.pttStatus.permission": "Permission needed. Mic closed.",
  "audio.pttStatus.recovering": "Key unavailable. Mic closed.",
  "audio.pttStatus.unsupported": "Choose another key. Mic closed.",
  "audio.pttStatus.local": "Works only in the active Gwar window.",
  "audio.pttStatus.legacy": "This key is reserved for Gwar.",
  "audio.pttDetail.ready": "Gwar observes only your chosen key or mouse button. Pressing it still reaches the app you are using. Left and right modifiers are separate keys.",
  "audio.pttDetail.permission": "To use this key outside Gwar, allow Gwar in System Settings → Privacy & Security → Input Monitoring. The Allow button opens that page. Your microphone stays closed until access is granted. Gwar checks automatically, without asking again. You may need to restart Gwar if macOS asks.",
  "audio.pttDetail.recovering": "Gwar cannot safely check your key right now, so your microphone is closed. It retries automatically. After sleep or unlocking, release the key and press it again.",
  "audio.pttDetail.unsupported": "This system cannot reliably observe this key being held. Choose another key or a mouse side button. On macOS, Caps Lock switches a mode rather than reporting a reliable hold.",
  "audio.pttDetail.local": "Your browser or desktop cannot observe this input outside Gwar. Keep Gwar focused while talking. On Linux, support depends on your desktop; some desktops do not allow keys outside the active window.",
  "audio.pttDetail.legacy": "This Linux desktop uses the existing global keyboard shortcut. Other apps may not receive that key. Mouse buttons and unsupported keys work only while Gwar is focused.",
  "audio.pttPrivacy": "No other input is stored, logged or forwarded. Only your bound input’s pressed/released state is used.",
  "audio.pttRecovery": "If observing the global key fails, the microphone closes without the release delay. Release and press again after recovery.",
  "audio.pttSettingsFailed": "Open System Settings → Privacy & Security → Input Monitoring and enable Gwar.",
  "audio.key.ControlLeft": "Left Ctrl",
  "audio.key.ControlRight": "Right Ctrl",
  "audio.key.ShiftLeft": "Left Shift",
  "audio.key.ShiftRight": "Right Shift",
  "audio.key.AltLeft": "Left Alt",
  "audio.key.AltRight": "Right Alt",
  "audio.key.MetaLeft": "Left Cmd/Win",
  "audio.key.MetaRight": "Right Cmd/Win",
  "audio.key.Mouse3": "Mouse 3",
  "audio.key.Mouse4": "Mouse 4",
  "audio.key.Mouse5": "Mouse 5",
  "audio.mouseButton": "Choose a mouse button",
  "voice.choosePttKey": "Choose a push-to-talk key in Audio settings",
  "voice.openAudioSettings": "Open Audio settings.",
  "audio.setKey": "Choose a key",
  "audio.clearKey": "Clear",
  "audio.pttHelp": "The key works while this window is active.",
  "audio.pttNoKey": "Choose a key to talk.",
  "audio.pttHelpGlobal": "The key also works outside Gwar.",
  "audio.globalShortcuts": "Global shortcuts",
  "audio.muteShortcut": "Mute microphone",
  "audio.deafenShortcut": "Deafen",
  "audio.shortcutHint": "Work even while Gwar is in the background.",
  "audio.shortcutNone": "Not set",
  "audio.shortcutSet": "Set shortcut",
  "audio.shortcutFailed": "Couldn't register {key} as a global shortcut. Another app may be using it.",
  "desktop.window": "Window",
  "desktop.closeToTray": "Keep running in the tray when closed",
  "desktop.closeToTrayHint": "Closing the window hides Gwar to the system tray. Use the tray menu to quit.",
  "audio.level": "Microphone level",
  "audio.processing": "Processing",
  "audio.noiseSuppression": "Noise suppression",
  "audio.noiseSuppressionHint": "Reduces background noise and tapping.",
  "audio.noiseStrength": "Noise suppression strength",
  "audio.noiseStrengthHint": "At 100% it takes out all the noise it can, typing too. Lower leaves some of the background in.",
  "audio.echoCancellation": "Echo cancellation",
  "audio.echoCancellationHint": "Removes echo from speakers.",
  "audio.autoGain": "Automatic volume",
  "audio.autoGainHint": "Adjusts your voice volume.",

  "appearance.theme": "Theme",
  "appearance.system": "System",
  "appearance.dark": "Dark",
  "appearance.light": "Light",
  "appearance.channelList": "Channel list",
  "appearance.compact": "Compact mode",
  "appearance.compactHint": "Tighter rows so more channels and users fit on screen.",

  "identity.profile": "Profile",
  "identity.away": "Away message",
  "identity.awayHint": "Shown next to your name. Leave empty to be available.",
  "identity.title": "Your identity",
  "identity.description":
    "Your identity is a key stored in this browser. Servers recognise you by it, so your groups and permissions stay with it. There is no account or password.",
  "identity.uid": "User ID",
  "identity.publicKey": "Public key",
  "identity.backup": "Backup",
  "identity.backupHint": "Export your identity to keep it safe or to use it in another browser or the desktop app.",
  "identity.export": "Export identity",
  "identity.import": "Import identity",
  "identity.importWarning": "The export file contains your private key. Keep it secret. Importing replaces the identity in this browser.",
  "identity.imported": "Identity imported. Reconnect to use it.",
  "identity.importFailed": "That file is not a valid identity backup.",

  "security.fingerprint": "Server key fingerprint",
  "security.fingerprintHelp": "Compare it with the server owner to make sure you are connected to the right server.",
  "ss.ownership": "Ownership",
  "own.none": "This server has no owner yet. Its operator names one with `gwar-server owner set`, or whoever redeems the first admin token becomes it.",
  "own.verifying": "Checking the owner record…",
  "own.owner": "Owner",
  "own.verified": "Checked by this device against the owner record it keeps for this server.",
  "own.confirmers": "Confirmers",
  "own.confirmersHint": "Confirmers may add and remove the managers of encrypted private channels. Only the owner names them.",
  "own.saveConfirmers": "Save confirmers",
  "own.managers": "Managers",
  "own.managersHint": "Managers may create and change encrypted private channels. The list follows who may edit channels, once the owner or a confirmer confirms it.",
  "own.pending": "Waiting for confirmation",
  "own.allow": "Allow",
  "own.remove": "Remove",
  "own.nobody": "Nobody",
  "own.signedBy": "List signed by {name} on {date}.",
  "own.transfer": "Transfer ownership",
  "own.transferHint": "The new owner gets the Admin role and decides who confirms managers. You keep your roles. This cannot be undone by you.",
  "own.transferTo": "New owner",
  "own.transferConfirm": "Make {name} the owner",
  "own.password": "Account password",
  "own.passwordHint": "The owner's account key signs this, so it needs your Gwar Connect password.",
  "own.staleTitle": "Confirmers who may no longer edit channels",
  "own.staleBody": "{names} may no longer edit channels but can still confirm managers. Remove them in Server settings → Ownership (your account password signs the change).",
  "own.open": "Open",
  "own.allowTitle": "A new manager",
  "own.allowBody": "Allow {name} to manage private channels?",
  "owner.changed": "This server’s owner record changed in a way it cannot. Disconnected: it may not be the server you know.",
  "owner.newTitle": "The server has a new owner",
  "owner.newBody": "The server’s operator made {name} its new owner, for example after the old owner lost their account. Accept the change? Private channels then need the new owner’s confirmation.",
  "owner.accept": "Accept",
  "security.changedTitle": "Server identity changed",
  "security.changedBody": "This server’s identity changed. This can mean a different server or an attack. Check the fingerprint with the server owner before trusting the new key.",
  "security.inviteMismatch": "The server key does not match this invite. The connection is blocked. Obtain a trusted invite from the server owner.",
  "security.oldKey": "Expected key",
  "security.newKey": "Presented key",
  "security.trustDanger": "Dangerous: forget old pin and trust new key",
  "security.insecureLan": "Insecure connection (LAN)",
  "security.insecureWarning": "This connection can be impersonated or taken over. Traffic is not encrypted.",

  "server.menu": "Server menu",
  "server.switchTitle": "Open another server?",
  "server.switchBody": "Leave the voice call on {from} to open {to}?",
  "server.switchConfirm": "Leave and open",
  "server.reconnecting": "Reconnecting…",
  "server.settings": "Server settings",
  "server.createChannel": "Create channel",
  "server.createToken": "Create invite token",
  "server.redeem": "Redeem token",
  "server.copyAddress": "Copy server address",
  "server.key": "Server key",
  "server.disconnect": "Disconnect from server",
  "serverSettings.name": "Server name",
  "serverSettings.welcome": "Welcome message",
  "serverSettings.welcomeHint": "Shown to everyone who joins.",

  "toast.copied": "Copied",
  "toast.copyFailed": "Could not copy to the clipboard.",

  "tree.label": "Channels and users",
  "tree.empty": "No channels yet",
  "tree.emptyHint": "Channels created on this server will appear here.",
  "tree.locked": "Password protected",
  "tree.join": "Join channel",
  "tree.joinVoice": "Join voice",
  "tree.joinVoiceNamed": "Join voice in {name}",
  "tree.openChat": "Open chat",
  "tree.inVoice": "you are in voice here",
  "tree.unread": "{count} unread",
  "tree.createSub": "Create subchannel",
  "tree.edit": "Edit channel",
  "tree.deleteTitle": "Delete “{name}”?",
  "tree.deleteBody": "Its subchannels are removed too. People inside are moved to the default channel.",
  "tree.away": "away",
  "tree.muted": "Muted",
  "tree.deafened": "Deafened",
  "tree.volume": "Volume",
  "tree.volumeReset": "Reset to 100%",
  "tree.pm": "Send private message",
  "tree.moveHere": "Move to my channel",
  "tree.kickTitle": "Kick {name}?",
  "tree.kickBody": "They are disconnected from the server and can reconnect right away.",
  "tree.kick": "Kick from server",
  "tree.kickChannel": "Kick from channel",
  "tree.info": "Channel info",
  "tree.moveUp": "Move up",
  "tree.moveDown": "Move down",
  "tree.you": "This is you",

  "channel.createTitle": "Create channel",
  "channel.editTitle": "Edit channel",
  "channel.name": "Name",
  "channel.topic": "Topic",
  "channel.parent": "Parent channel",
  "channel.noParent": "None (top level)",
  "channel.password": "Password",
  "channel.passwordNone": "Leave empty for an open channel.",
  "channel.passwordKeep": "Leave empty to keep the current password.",
  "channel.passwordWillRemove": "The password will be removed.",
  "channel.private": "Private",
  "channel.privateHint": "Only the roles and members you choose, and admins, can see this channel. TeamSpeak users never see it.",
  "channel.access": "Who can see this channel",
  "channel.accessHint": "Admins can always see private channels.",
  "channel.accessRoles": "Roles",
  "channel.accessMembers": "Members",
  "channel.accessFilter": "Filter members",
  "channel.membersHint": "Encrypted: only these people can read it, by a member list you sign. The owner, confirmers and managers are always admitted.",
  "channel.addRole": "Add everyone with {role}",
  "channel.membersSigned": "Member list signed by {name}, {date}",
  "channel.membersAuthority": "Only the server's owner, confirmers and managers can create or edit an encrypted private channel (Server settings → Ownership).",
  "channel.membersLoading": "Loading the signed member list…",
  "tree.private": "Private channel",
  "tree.full": "Channel is full",
  "tree.limit": "User limit: {max}",
  "tree.familyLimit": "{count} of {max} allowed in this channel and its subchannels",
  "chinfo.topic": "Topic",
  "chinfo.description": "Description",
  "chinfo.noDescription": "No description.",
  "chinfo.loading": "Loading the description…",
  "chinfo.limit": "User limit",
  "chinfo.familyLimit": "Limit with subchannels",
  "chinfo.none": "None",
  "chinfo.password": "Password",
  "chinfo.passwordRequired": "Required",
  "poke.action": "Poke…",
  "poke.title": "{name} pokes you",
  "poke.received": "{name} pokes you: {message}",
  "poke.receivedEmpty": "{name} pokes you",
  "poke.dialogTitle": "Poke {name}",
  "poke.dialogBody": "A poke pops up for them at once, with your message.",
  "poke.message": "Message",
  "poke.send": "Poke",
  "poke.sent": "Poked {name}",
  "tree.default": "Default channel",
  "channel.encrypted": "End-to-end encrypted",
  "channel.encryptedHint": "Only members' devices can read messages. TeamSpeak users can't join.",
  "channel.history": "New members see earlier messages",
  "channel.historyHint": "Members' devices share earlier messages with people who join later.",
  "channel.encryptionPermanent": "These options can't be changed after the channel is created.",
  "channel.readers": "Who can read",
  "chat.serverReadersHint": "Devices in this conversation's group, as this device sees it.",
  "chat.serverReadersPending": "This conversation is still being secured on this device.",
  "channel.readersHint": "Devices in this channel's group, as this device sees it.",
  "channel.hearers": "Who can hear",
  "channel.hearersHint": "Devices in this call's voice group, as this device sees it.",
  "channel.hearersJoin": "Join voice to see who can hear.",
  "channel.hearersPending": "This call is still being secured on this device.",
  "channel.readersPending": "This channel is still being secured on this device.",
  "channel.devices.one": "{count} device",
  "channel.devices.other": "{count} devices",
  "channel.devices.few": "{count} devices",
  "channel.devices.many": "{count} devices",
  "chat.messagesEncrypted": "Messages are end-to-end encrypted",
  "chat.historyNotShared": "Earlier messages aren't shared with new members.",
  "chat.restarted": "This conversation was restarted.",
  "channel.removePassword": "Remove the password",
  "channel.maxClients": "Max users",
  "channel.maxHint": "Empty = unlimited.",
  "channel.maxInvalid": "Max users must be a number from 1 to 1000.",
  "channelPassword.title": "Join “{name}”",
  "channelPassword.description": "This channel is protected by a password.",
  "channelPassword.wrong": "Wrong password.",

  "redeem.title": "Redeem token",
  "redeem.description": "Paste an invite or admin token to receive its permissions.",
  "redeem.token": "Token",
  "redeem.submit": "Redeem",
  "redeem.success": "Token redeemed. Your groups: {groups}.",
  "redeem.invalid": "That token is invalid or has already been used.",
  "token.title": "Create invite token",
  "token.description": "Whoever redeems the token joins the chosen group. Each token works once.",
  "token.group": "Group",
  "token.create": "Create token",
  "token.created": "Share this token with the person you want to invite:",
  "token.once": "It cannot be shown again after you close this window.",

  "voice.mute": "Mute microphone",
  "voice.unmute": "Unmute microphone",
  "voice.deafen": "Deafen (mute sound and microphone)",
  "voice.undeafen": "Undeafen",
  "voice.connected": "Voice connected",
  "voice.connecting": "Connecting voice…",
  "voice.reconnecting": "Reconnecting voice…",
  "voice.failed": "Voice unavailable",
  "voice.retry": "Retry",
  "voice.why": "Why?",
  "voice.retryMic": "Try again",
  "voice.openPrivacySettings": "Open privacy settings",
  "voice.leave": "Leave voice",
  "voice.pill": "Voice connection",
  "voice.pillOpen": "Go to the voice channel",
  "voice.quality.good": "Good connection",
  "voice.quality.fair": "Fair connection",
  "voice.quality.poor": "Poor connection",
  "voice.quality.upload": "Upload can't keep up",
  "voice.quality.open": "{quality} · {ms} ms. Show details",
  "voice.quality.title": "Connection quality",
  "voice.quality.notice": "Your internet can't keep up with uploading — others hear you about {delay} s late.",
  "voice.quality.showDetails": "Details",
  "screen.quality.goodExplain": "Screen sharing is working without a noticeable delay.",
  "screen.quality.uploadExplain": "Your internet can't keep up with uploading your screen. The picture may lag or freeze.",
  "screen.quality.slowExplain": "The connection to the server is slow or unstable, so your shared screen may lag or freeze.",
  "screen.quality.uploadTech": "An upload queue in your router or modem can delay your shared screen. Enable SQM or QoS (for example CAKE or fq_codel) with the upload limit slightly below your connection's speed. Gwar infers this from rising delay; it cannot tell which app is uploading.",
  "voice.quality.none": "No measurements yet.",
  "voice.quality.goodExplain": "Everything looks fine: others hear you without a noticeable delay.",
  "voice.quality.uploadExplain": "Your internet can't keep up with uploading, so others hear you about {delay} s late. This usually happens when something else on this device or network is sending a lot of data.",
  "voice.quality.uploadFix": "Pause file uploads, backups, cloud sync or another call on this device or network. Downloads usually keep working normally.",
  "voice.quality.slowExplain": "The connection to the server is slow or unstable, so voice may lag or cut out.",
  "voice.quality.slowFix": "If you can, use a cable or move closer to the Wi-Fi router, and close other apps that use the internet.",
  "voice.quality.technical": "Technical details",
  "voice.quality.ping": "Round trip to the server",
  "voice.quality.usual": "Usually",
  "voice.quality.loss": "Packet loss",
  "voice.quality.uploadRate": "Estimated upload",
  "voice.quality.uploadTech": "This is called bufferbloat: the queue in your router or modem fills with data another app is uploading, and voice waits behind it. If it happens often, enable SQM or QoS on the router (for example CAKE or fq_codel) with the upload limit slightly below your connection's speed. Gwar infers this from rising delay; it cannot tell which app is uploading.",
  "voice.notIn": "Not in voice",
  "voice.notInHint": "Double-click a channel to talk",
  "voice.pttHint": "Push to talk: hold {key}",
  "voice.encryptedUnsupported": "Update your browser or use the desktop app to join encrypted voice.",
  "voice.securing": "Securing voice…",
  "voice.channelSecuring": "This encrypted channel is still being secured on this device. Try again in a moment.",
  "voice.securingTimeout": "Encrypted voice could not be secured. Try again.",
  "voice.closed": "The voice connection was closed. Reconnecting…",
  "voice.deviceSwitched": "Switched to: {device}",
  "screen.share": "Share screen",
  "screen.stop": "Stop sharing",
  "screen.encryptedSoon": "Screen sharing in encrypted channels is coming soon.",
  "screen.unsupported": "This browser can't share the screen.",
  "screen.insecure": "Screen sharing needs a secure connection (https).",
  "screen.needsMacos": "Screen sharing needs macOS 14.6 or later.",
  "screen.desktopSoon": "Screen sharing in the desktop app is coming soon. Use the browser for now.",
  "screen.noPermission": "You can't share your screen in this channel.",
  "screen.channelFull": "This channel already has as many screen shares as allowed.",
  "screen.alreadySharing": "You are already sharing your screen.",
  "screen.reconnectStopped": "Screen sharing stopped after the connection was lost.",
  "screen.reconnectStoppedShort": "Sharing stopped",
  "screen.shareAgainShort": "Share",
  "screen.watchReconnecting": "Reconnecting to the screen share…",
  "screen.reconnecting": "Reconnecting screen share…",
  "screen.permission": "Allow screen recording for {app} in {settings}.",
  "screen.permissionHint": "If you cancelled the picker, ignore this; otherwise allow screen recording for {app} in your system or browser privacy settings.",
  "screen.permissionTitle": "Screen recording isn't allowed",
  "screen.permissionShort": "No screen access",
  "screen.permissionFix": "How to fix",
  "screen.permissionHintTitle": "Couldn't share your screen",
  "screen.permissionHintShort": "Couldn't share screen",
  "screen.permissionHintFix": "How to fix",
  "screen.permissionPlace.macos": "System Settings → Privacy & Security → Screen & System Audio Recording",
  "screen.permissionPlace.windows": "Settings → Privacy & security",
  "screen.permissionPlace.other": "your system or browser privacy settings",
  "screen.openSettings": "Open settings",
  "screen.publishFailed": "Could not start screen sharing. Please try again.",
  "screen.browser": "your browser",
  "screen.captureFailed": "Could not capture your screen. Try sharing another window.",
  "screen.presetTitle": "Share your screen",
  "screen.stopShort": "Stop",
  "screen.playAudio": "Play share sound",
  "screen.audioSharing": "Tab sound is shared.",
  "screen.computerSound": "Share computer sound",
  "screen.computerSoundHint": "Viewers hear what you hear, except sounds from Gwar.",
  "screen.computerSoundSharing": "Computer sound is shared, except sounds from Gwar.",
  "screen.computerSoundReady": "Computer sound will be shared, except sounds from Gwar.",
  "screen.computerSoundOff": "Computer sound is not shared.",
  "screen.computerSoundStopped": "Computer sound is off for this share. Start a new share to turn it back on.",
  "screen.computerSoundOffLive": "Computer sound is off. The picture is still shared.",
  "screen.computerSoundResuming": "Bringing computer sound back. The picture is still shared.",
  "screen.computerSoundFailed": "Computer sound is not available, so only the picture is shared.",
  "screen.computerSoundUnsupported": "Computer sound needs macOS 14 or Windows 11, or newer. Only the picture is shared.",
  "screen.computerSoundPermission": "Turn on Gwar in System Settings → Privacy & Security → Screen & System Audio Recording, then reopen Gwar.",
  "screen.computerSoundPermissionLive": "Turn on Gwar in System Settings → Privacy & Security → Screen & System Audio Recording and come back here. If sound stays off, reopening Gwar will fix it, but that ends this share.",
  "screen.stopComputerSound": "Stop sharing sound",
  "screen.soundTurnOn": "Turn on sound",
  "screen.soundTurningOn": "Turning on sound",
  "screen.soundFailed": "Sound did not turn on. The picture is still shared.",
  "screen.audioAddHint": "Only the picture is shared. Choose a browser tab to add its sound; your picture stays as it is.",
  "screen.audioChooseTab": "Choose a tab",
  "screen.audioServer": "Sound is not available on this server.",
  "screen.audioReady": "Tab sound will be shared.",
  "screen.audioUnavailable": "No sound from this choice. Try a browser tab with audio enabled.",
  "screen.audioOn": "Sound on",
  "screen.sharingAudio": "Sharing with sound",
  "screen.audioResuming": "Restoring sound",
  "screen.audioOff": "No sound",
  "screen.shareVolume": "Share volume",
  "screen.muteAudio": "Mute share sound",
  "screen.unmuteAudio": "Unmute share sound",
  "screen.presetHint": "Pick what matters most. You can change it while sharing.",
  "screen.surface.screen": "Sharing your entire screen",
  "screen.surface.window": "Sharing a window",
  "screen.surface.tab": "Sharing a browser tab",
  "screen.surface.unknown": "Sharing your screen",
  "screen.preset": "Quality",
  "screen.mode": "Mode",
  "screen.mode.smooth": "Smoothness",
  "screen.mode.sharp": "Sharp text",
  "screen.resolution": "Resolution",
  "screen.frameRate": "Frame rate",

  "screen.start": "Share",
  "screen.sharingBar": "You are sharing your screen",
  "screen.watching.one": "{count} watching",
  "screen.watching.few": "{count} watching",
  "screen.watching.many": "{count} watching",
  "screen.watching.other": "{count} watching",
  "screen.starting": "Starting…",
  "screen.preview": "Preview",
  "screen.limitedCpu": "Limited by this computer",
  "screen.limitedBandwidth": "Limited by connection",
  "screen.encoder": "Encoder: {name} ({kind})",
  "screen.encoderHardware": "hardware",
  "screen.encoderSoftware": "software",
  "screen.encoderUnknown": "type unknown",
  "screen.live": "LIVE",
  "screen.liveTitle": "{name} is sharing their screen. Click to watch.",
  "screen.liveSelf": "You are sharing your screen",
  "screen.liveDesktop": "{name} is sharing their screen. Watching needs the browser for now.",
  "screen.watch": "Watch",
  "screen.stopWatching": "Stop watching",
  "screen.fullscreen": "Fullscreen",
  "screen.exitFullscreen": "Exit fullscreen",
  "screen.pip": "Picture in picture",
  "screen.showChat": "Show chat",
  "screen.hideChat": "Hide chat",
  "screen.stage": "Screen shares",
  "screen.sharerTitle": "{name}'s screen",
  "screen.connecting": "Connecting to the share…",
  "screen.pausedBandwidth": "Your connection can't keep up, so the picture is paused to keep voice clear. It comes back on its own.",
  "screen.pausedWaiting": "Your connection can't keep up, so the picture is paused. Once it's better, click “Try again”.",
  "screen.pausedBudget": "Paused while the server makes room. Waiting to resume…",
  "screen.pausedShort": "Paused",
  "screen.pausedLink": "Paused – weak connection",
  "screen.retry": "Try again",
  "screen.retryIn": "Retrying in {seconds} s",
  "screen.retrying": "Retrying…",
  "screen.ended": "The screen share has ended.",
  "screen.noLongerWatch": "You can no longer watch this screen share.",
  "screen.joinToWatch": "Join this channel to watch its screen share.",
  "screen.slotLimit": "You can watch up to 4 screen shares at once. Stop watching one first.",
  "screen.viewerLimit": "This screen share has as many viewers as allowed.",
  "screen.watchFailed": "The connection for watching screen shares was lost.",
  "screen.stopped.moderator": "{name} stopped your screen share.",
  "screen.stopped.limit": "Your screen share was stopped: it sent more than the server allows.",
  "screen.stopped.transport": "Your screen share could not connect.",
  "screen.stopped.encoder": "Your screen share was stopped: this browser could not encode the video.",
  "screen.stopped.budget": "Your screen share was stopped: the server's screen sharing capacity is full.",
  "screen.cantDecode": "Your browser cannot decode this screen share. Ask the sharer to use a compatible browser or codec.",
  "screen.stopped.access": "Your screen share was stopped: you can no longer share in this channel.",
  "screen.stopOther": "Stop screen share",
  "screen.tsNotice": "TeamSpeak users in this channel can watch through a link. Anyone with the link can watch.",
  "screen.tsPost": "Post a watch link to TeamSpeak",
  "screen.tsLinkOn": "TeamSpeak link on",
  "screen.guests.one": "{count} guest",
  "screen.guests.few": "{count} guests",
  "screen.guests.many": "{count} guests",
  "screen.guests.other": "{count} guests",
  "screen.tsTurnOff": "Turn off",
  "screen.tsTurnOffTitle": "Turn the TeamSpeak link off for this share. Its guests stop watching.",
  "screen.tsTurnOffOther": "Turn off TeamSpeak link",

  "chat.today": "Today",
  "chat.yesterday": "Yesterday",
  "chat.serverWelcome": "Server welcome message",
  "chat.messages": "Messages",
  "chat.conversationBeginning": "This is the beginning of the conversation.",
  "chat.beginning": "This is the beginning of the channel history.",
  "chat.empty": "No messages yet",
  "chat.emptyChannel": "Say hello to everyone in this channel. Messages here are saved.",
  "chat.emptyChannelElsewhere": "TeamSpeak shows a channel's messages only to the people in it. Join this channel to read and write here.",
  "chat.emptyChannelNoHistory": "Say hi to everyone in this channel. TeamSpeak servers don't keep message history, so messages are only visible while you are connected.",
  "chat.emptyServer": "Messages here go to everyone on the server and are not saved.",
  "chat.emptyServerHistory": "Messages here go to everyone on the server and are saved.",
  "chat.emptyDm": "Private messages are only visible to you two and are not saved.",
  "chat.jump": "Jump to latest",
  "chat.compose": "Message",
  "chat.placeholderChannel": "Message #{name}",
  "chat.placeholderServer": "Message everyone on the server",
  "chat.placeholderDm": "Message {name}",
  "chat.peerOfflineNamed": "{name} is offline",
  "chat.peerOffline": "That user is no longer connected.",
  "chat.send": "Send message",
  "chat.closeDm": "Close conversation",
  "chat.conversations": "Conversations",
  "chat.channel": "Channel",
  "chat.server": "Server",
  "chat.noTopic": "No topic set",
  "chat.serverHint": "Everyone on {name}",
  "chat.securing": "Securing this conversation…",
  "chat.waitingManager": "Waiting for a channel manager to confirm access…",
  "chat.cannotOpen": "Can't open this message on this device",
  "chat.noKeyReason": "This device does not have the key for this message yet.",
  "chat.cannotOpenReason": "This message could not be authenticated.",
  "chat.waitingHistory": "Earlier messages will appear when another member is online.",
  "chat.deleted": "Deleted",
  "chat.encrypted": "End-to-end encrypted",
  "chat.notEncrypted": "Not end-to-end encrypted",
  "chat.dmHint": "Private conversation",
  "chat.users.one": "{count} user in voice",
  "chat.users.other": "{count} users in voice",
  "chat.users.few": "{count} users in voice",
  "chat.users.many": "{count} users in voice",
  "chat.members": "Members",
  "chat.lockedTitle": "Password channel",
  "chat.lockedHint": "Enter the password to join this channel. Its chat opens once you are in.",
  "chat.lockedAction": "Enter password",
  "chat.placeholderLocked": "This channel is locked",
  "chat.joiningShort": "Joining",
  "chat.notSent": "Not sent",
  "chat.locked": "That channel is password protected",
  "chat.retry": "Send again",
  "chat.sending": "Sending…",
  "chat.maybeSent": "May have been sent or removed",
  "chat.failed.lost": "The connection was lost.",
  "chat.failed.securing": "The conversation was still being secured.",
  "chat.failed.peerOffline": "They were offline.",
  "chat.missingAttachments": "Attach the file again to send it.",
  "chat.dismiss": "Dismiss",
  "chat.reconnecting": "Connection lost. Reconnecting…",

  "members.title": "Members",
  "members.voice": "In voice",
  "members.online": "Online",
  "members.offline": "Offline",
  "members.admin": "Administrator",
  "members.lastSeen": "Last seen {when}",
  "members.lastSeenUnknown": "Last seen: unknown",
  "members.openChat": "Message {name}",

  "sys.welcome": "{text}",
  "sys.user_joined_channel": "{name} joined the channel",
  "sys.user_left_channel": "{name} left the channel",
  "sys.you_joined_channel": "You joined {name}",
  "sys.reconnected": "Reconnected to the server",

  "err.connect.unreachable": "Can't reach the server. Check the address and that the server is running.",
  "err.connect.timeout": "The server did not answer in time. Try again in a moment.",
  "err.connect.password_required": "{server} needs a password. Enter it below to continue.",
  "err.connect.wrong_password": "Wrong server password. Try again.",
  "err.connect.server_full": "The server is full right now. Try again later.",
  "err.connect.rejected": "The server refused the connection. Check your nickname and try again.",
  "err.connect.certificate_expired": "Enter your Gwar Connect password again on this device to connect.",
  "err.connect.protocol": "This server speaks a different protocol version. Update the client or the server.",
  "err.connect.storage_newer": "A newer version of Gwar saved this device's identity or sign-in, and this version can't read it. Nothing was changed: reload the page or install the latest Gwar.",
  "err.connect.identity_unreadable": "The identity saved on this device can't be read by this version of Gwar. It was left as it is: update Gwar, or import a backup in Settings → Identity.",
  "err.connect.trust_storage": "This device's saved server keys couldn't be read or saved, so Gwar trusts no server key right now. Reload the page; if a newer version of Gwar saved them, update Gwar.",
  "err.connect.identity_storage": "This device's saved identity couldn't be loaded because its storage failed. Reload the page; if this keeps happening, the browser may be blocking site data.",
  "err.connect.identity": "Your browser can't create a secure identity here. Use a recent browser over https (or localhost).",
  "err.connect.address": "That server address doesn't look right.",
  "err.addr.empty": "Enter a server address.",
  "err.addr.invalid": "That server address doesn't look right.",
  "err.addr.scheme": "Only ws://, wss://, http:// and https:// addresses are supported.",
  "err.addr.mixed_content": "This server doesn't use HTTPS, so the web app can't connect to it. Ask its owner to enable HTTPS, or use the desktop app.",
  "err.addr.insecure": "TLS is required. In the desktop app you can explicitly enable Insecure connection (LAN) for this server.",
  "err.connect.unreachableHttps": "Can't reach the server. Check the address and that the server is running. The web app can only connect to servers that use HTTPS; if this one doesn't, ask its owner to enable it, or use the desktop app.",

  "err.req.bad_request": "Couldn’t complete this action. Check what you entered and try again.",
  "err.req.not_authenticated": "You are not signed in.",
  "err.req.not_found": "That no longer exists.",
  "err.req.forbidden": "You don't have permission to do that.",
  "err.req.wrong_password": "Wrong password.",
  "err.req.channel_full": "That channel is full.",
  "err.req.rate_limited": "You're doing that too fast. Slow down a little.",
  "err.req.conflict": "That conflicts with something that already exists",
  "err.req.unavailable": "The server can't do that right now.",
  "err.req.internal": "Something went wrong on the server.",
  "err.req.timeout": "The server took too long to answer.",
  "err.req.lost": "You are offline. Reconnecting…",

  "err.voice.mic_denied": "Microphone access is blocked. You can still chat and listen. Allow the microphone in your browser's site settings to talk.",
  "err.voice.mic_denied_desktop": "Microphone access is blocked. You can still chat and listen. Allow Gwar to use the microphone in your system's privacy settings.",
  "err.voice.output_failed": "The speakers couldn't be opened. Check the output device in Settings.",
  "err.voice.no_mic": "No microphone found. You can still chat and listen.",
  "err.voice.mic_failed": "The microphone couldn't be opened (is another app using it?). You can still chat and listen.",
  "err.voice.mic_stop_failed": "The microphone couldn't be stopped in time. Your recording wasn't played.",
  "err.voice.mic_stopping": "The microphone is still stopping. Try again shortly.",
  "err.voice.insecure": "Browsers only allow the microphone on https or localhost. You can still chat and listen.",
  "err.voice.negotiation": "Couldn't set up the audio connection. Chat still works.",
  "err.voice.unsupported": "This browser doesn't support voice. Chat still works.",

  "chat.edit": "Edit message",
  "chat.delete": "Delete message",
  "chat.deleteTitle": "Delete this message?",
  "chat.deleteBody": "This message will be removed for everyone. Hold Shift while clicking delete to skip this question.",
  "chat.editing": "Edit message",
  "chat.editHint": "Enter to save, Escape to cancel",
  "chat.notVerified": "Unsigned: this server may have forged or altered this message",
  "chat.invalid": "Not verified",
  "chat.signatureInvalid": "Invalid signature or message routing",
  "chat.signatureValid": "Signature valid",
  "chat.rollback": "An earlier message revision was replayed (rollback)",
  "chat.fork": "Conflicting message revisions (fork)",
  "chat.deviceRevoked": "signing device revoked; signing time unproven",
  "chat.certificateExpired": "certificate expired; signing time unproven",
  "chat.channelReused": "the server reused the id of a channel deleted earlier, so this message may come from the deleted channel",
  "chat.channelHistoryIncomplete": "this client could not keep a complete record of this server's deleted channels, so it cannot rule out a reused channel id",
  "chat.revocationsStale": "revocation information stale or unavailable",
  "chat.continuityUnproven": "continuity unproven; this device has no record of earlier versions, so it cannot detect a rollback. Older evicted history also has no rollback protection",
  "chat.checkpointsUnavailable": "this device cannot use its local storage for message checks right now, so it cannot detect a rollback. The check runs again once storage works; if this persists, the browser may be blocking site data (for example in a private window)",
  "chat.teamSpeakNotification": "TeamSpeak / unsigned",
  "chat.teamSpeakUnsigned": "TeamSpeak messages are unsigned: this server may have forged or altered this message",
  "chat.serverRemoved": "Message removed by the server",
  "chat.authorDeleted": "Deleted by the author",
  "chat.unverifiedDeletion": "Unverified deletion request",
  "chat.verificationQueueFull": "Message verification queue is full",
  "chat.replacementRejected": "Message replacement rejected: invalid signature, rollback or fork",
  "chat.editInProgress": "This message is already being changed",
  "chat.editChanged": "The message changed in the meantime; try again",
  "chat.editUnverified": "This message could not be verified, so it cannot be edited or deleted with your signature",
  "chat.verifying": "Checking the signature…",
  "chat.edited": "(edited)",
  "chat.editedAt": "Edited {when}",
  "close.banned": "You were banned from the server by {by}.",
  "close.bannedUntil": "The ban lasts until {when}.",
  "close.bannedReason": "Reason: {reason}",
  "err.connect.banned": "You are banned from this server.",
  "err.connect.invite": "That invite is invalid, expired or used up. Ask for a new one, or enter the server password.",
  "err.req.banned": "You are banned from this server.",
  "err.req.too_large": "That is too large.",
  "err.join.forbidden": "You aren't allowed to join this channel.",
  "err.req.quota_exceeded": "There is no storage space left for that.",
  "err.req.partial": "Only part of that went through",
  "connect.invited": "You were invited to this server. Connect to join.",
  "connect.inviteForget": "Ignore invite",
  "file.attachment": "Attachment",
  "file.missing": "Missing",
  "file.attach": "Attach files",
  "file.attachInput": "Attach files",
  "file.pending": "Files to send",
  "file.remove": "Remove {name}",
  "file.dropHint": "Drop files to send them",
  "file.channelOnly": "Files can only be sent in channel chats.",
  "file.disabled": "File uploads are not available here.",
  "file.tooLarge": "That file is too large. The limit is {limit}.",
  "file.quota": "No upload space left: your files or the server's storage reached the limit. Deleting messages with files frees space.",
  "file.tooMany": "You can attach up to {max} files to one message.",
  "file.empty": "That file is empty.",
  "file.forbidden": "You are not allowed to upload files.",
  "file.aborted": "Upload cancelled.",
  "file.networkFailed": "The upload failed. Check your connection and try again.",
  "file.notVerified": "Attachment verification failed",
  "file.loadFailed": "Couldn't load the attachment",
  "file.retry": "Try again",
  "file.cannotOpen": "Can't open this file",
  "file.verifying": "Verifying attachment…",
  "file.unverified": "Unverified attachment",
  "file.loadUnverified": "Load unverified attachment",
  "file.unverifiedRisk": "This attachment may have been substituted or altered by the server. Only open it if you trust its source.",
  "file.loadedUnverified": "Attachment loaded without verification",
  "file.downloadUnverified": "Download unverified attachment",
  "file.downloadUnverifiedNamed": "Download unverified attachment: {name}",
  "file.download": "Download",
  "file.downloadNamed": "Download {name}",
  "file.open": "Open {name}",
  "file.saveImage": "Save image",
  "file.saved": "Saved {name}",
  "file.saveFailed": "Couldn't save the file: {reason}",
  "mention.label": "People to mention",
  "tree.mentions": "Mentions of you: {count}",
  "server.invite": "Invite people",
  "settings.notifications": "Notifications",
  "notify.when": "Notify me about",
  "notify.mentions": "Mentions",
  "notify.mentionsHint": "When someone writes @your name.",
  "notify.dms": "Private messages",
  "notify.dmsHint": "When someone messages you directly.",
  "notify.all": "Every message",
  "notify.allHint": "All channel and server chat. Can get noisy.",
  "notify.backgroundOnly": "Notifications only appear while Gwar is in the background.",
  "notify.permission": "System permission",
  "notify.granted": "Notifications are allowed.",
  "notify.denied": "Notifications are blocked. Allow them in your browser's site settings.",
  "notify.deniedDesktop": "Notifications are blocked. Allow them for Gwar in your system settings.",
  "notify.allow": "Allow notifications",
  "notify.allowHint": "You will be asked once by your system.",
  "notify.dm": "{name} (private message)",
  "notify.channel": "{name} in #{channel}",
  "notify.server": "{name} on {server}",
  "mod.roles": "Roles",
  "mod.noRoles": "No roles yet",
  "mod.roleBlocked": "Only roles below your rank, for people ranked below you.",
  "mod.ban": "Ban…",
  "mod.banNamed": "Ban {name}",
  "mod.banTitle": "Ban {name}?",
  "mod.banBody": "They are disconnected now and can't join again until the ban ends or is lifted.",
  "mod.banned": "{name} was banned.",
  "mod.reason": "Reason",
  "mod.reasonHint": "Optional. They will see it.",
  "mod.duration": "Duration",
  "mod.dur.1h": "1 hour",
  "mod.dur.1d": "1 day",
  "mod.dur.7d": "7 days",
  "mod.dur.perm": "Permanent",
  "mod.alsoIp": "Also ban their IP address",
  "mod.alsoIpHint": "Blocks other accounts from the same address too.",
  "mod.alsoIpOffline": "Only possible while they are online.",
  "ss.overview": "Overview",
  "ss.roles": "Roles",
  "ss.members": "Members",
  "ss.bans": "Bans",
  "ss.invites": "Invites",
  "ss.readOnly": "You can look but not change this.",
  "ss.defaultChannel": "Default channel",
  "ss.defaultChannelHint": "Where people land when they join.",
  "ss.maxClients": "Max users",
  "ss.maxClientsHint": "How many people can be connected at once.",
  "ss.maxInvalid": "Max users must be a whole number of at least 1.",
  "ss.password": "Server password",
  "ss.passwordHint": "Leave empty to keep the current one. People with an invite don't need it.",
  "ss.passwordPlaceholder": "New password",
  "ss.membersOnlyFiles": "Files only for people on this server",
  "ss.membersOnlyFilesHint": "Off: a file link opens for anyone who has it, and TeamSpeak users get links. On: only people connected here who can read the channel open its files; TeamSpeak users see only file names.",
  "ss.screenGuestLinks": "TeamSpeak watch links",
  "ss.screenGuestLinksHint": "A screen share in a TeamSpeak channel can post a link there, so TeamSpeak users watch it in a browser. The sharer decides per share. Links also need files that open by link.",
  "ss.removePassword": "Remove the server password",
  "ss.createRole": "Create role",
  "viewAs.titleRole": "View as {name}",
  "viewAs.titleMember": "View as {name}",
  "viewAs.body": "The channels as they see them, and what they may do in each. Nothing changes.",
  "viewAs.role": "Role",
  "viewAs.server": "On the whole server",
  "viewAs.nothing": "Nothing beyond the channels below",
  "viewAs.channels": "Channels",
  "viewAs.col.connect": "Join",
  "viewAs.col.speak": "Speak",
  "viewAs.col.send_messages": "Write",
  "viewAs.col.attach_files": "Files",
  "viewAs.col.manage_channels": "Manage",
  "viewAs.yes": "Yes",
  "viewAs.no": "No",
  "viewAs.hidden": "{count} private channel(s) you can see are hidden from them.",
  "viewAs.limits": "Private channels you cannot see yourself are not shown. An encrypted private channel admits only its signed member list (and its managers), never a role.",
  "viewAs.open": "View as this role",
  "viewAs.openMember": "View the server as this member",
  "ss.builtin": "Built-in role",
  "ss.roleName": "Role name",
  "ss.roleColor": "Colour",
  "ss.noColor": "No colour",
  "ss.pickColor": "Pick a colour",
  "ss.colorInvalid": "Use a colour like #3498db.",
  "ss.permissions": "Permissions",
  "ss.adminAll": "Admin holds administrator: every permission, always.",
  "ss.roleOutranked": "This role is at or above your rank, so you can't change it.",
  "ss.deleteRoleTitle": "Delete the role “{name}”?",
  "ss.deleteRoleBody": "People who have it lose it, along with what it allowed.",
  "ss.searchMembers": "Search members",
  "ss.noMembers": "Nobody found",
  "ss.you": "you",
  "ss.editRoles": "Change roles of {name}",
  "ss.noBans": "No active bans",
  "ss.noBansHint": "People you ban will be listed here until the ban ends.",
  "ss.noReason": "No reason given",
  "ss.ipBan": "IP",
  "ss.bannedBy": "by {by}",
  "ss.permanent": "Permanent",
  "ss.expires": "ends {when}",
  "ss.unban": "Unban",
  "ss.unbanned": "Ban lifted.",
  "invite.title": "Invite people",
  "invite.description": "Share a link. Whoever opens it can join this server.",
  "invite.maxUses": "Uses",
  "invite.unlimited": "Unlimited",
  "invite.expiry": "Expires",
  "invite.exp.30m": "In 30 minutes",
  "invite.exp.1h": "In 1 hour",
  "invite.exp.1d": "In 1 day",
  "invite.exp.7d": "In 7 days",
  "invite.exp.never": "Never",
  "invite.role": "Role for new people",
  "invite.noRole": "No extra role",
  "invite.create": "Create invite",
  "invite.server": "Server: {address}",
  "invite.none": "No invites yet",
  "invite.noneHint": "Create one to get a link you can share.",
  "invite.list": "Invites",
  "invite.usesOf": "{uses} of {max} uses",
  "invite.usesCount": "{uses} uses",
  "invite.neverExpires": "never expires",
  "invite.expired": "expired",
  "invite.by": "by {name}",
  "invite.copyLink": "Copy link",
  "perm.section.server": "Server",
  "perm.section.channels": "Channels",
  "perm.section.people": "People",
  "perm.section.chat": "Chat",
  "mod.muteAll": "Mute for everyone",
  "mod.unmuteAll": "Unmute for everyone",
  "mod.deafenAll": "Deafen for everyone",
  "mod.undeafenAll": "Undeafen for everyone",
  "tree.serverMuted": "Muted by a moderator",
  "tree.serverDeafened": "Deafened by a moderator",
  "voice.serverMuted": "A moderator muted you: nobody hears you.",
  "voice.serverDeafened": "A moderator deafened you: you hear nothing and nobody hears you.",
  "voice.cannotSpeak": "You can't speak in this channel: nobody hears you.",
  "perm.mute_members": "Mute people",
  "perm.mute_members.hint": "Mute or deafen someone for everyone in voice.",
  "perm.connect": "Join voice",
  "perm.connect.hint": "Join a channel's voice.",
  "perm.speak": "Speak",
  "perm.speak.hint": "Be heard in a channel's voice.",
  "perm.share_screen": "Share screen",
  "perm.share_screen.hint": "Share a screen, window or tab in a channel's voice.",
  "perm.send_messages": "Send messages",
  "perm.send_messages.hint": "Write in a channel's chat (and in server chat).",
  "perm.section.voice": "Voice",
  "chat.placeholderJoinToWrite": "Join this channel to write here",
  "chat.placeholderNoWrite": "You can't write in this channel.",
  "chperm.open": "Permissions",
  "chperm.title": "Permissions: {name}",
  "chperm.description": "Allow or deny what a role or a person may do in this channel. Changes apply at once.",
  "chperm.synced": "Uses the permissions of {parent}.",
  "chperm.own": "Has its own permissions.",
  "chperm.unsync": "Set its own",
  "chperm.sync": "Follow {parent}",
  "chperm.editingSynced": "Changing anything here gives this channel its own permissions, starting from those of {parent}.",
  "chperm.targets": "Roles and people",
  "chperm.add": "Add a role or person…",
  "chperm.everyone": "Member (everyone)",
  "chperm.locked": "Only roles below yours and people ranked below you can be changed here.",
  "chperm.deny": "Deny",
  "chperm.inherit": "Inherit",
  "chperm.allow": "Allow",
  "chperm.whoJoins": "Can join voice:",
  "perm.administrator": "Administrator",
  "perm.administrator.hint": "Everything, everywhere. Rank still applies: administrators act only on people ranked below them.",
  "perm.manage_server": "Manage the server",
  "perm.manage_server.hint": "Change the name, welcome message, password and other server settings.",
  "perm.manage_roles": "Manage roles",
  "perm.manage_roles.hint": "Create, edit, reorder and delete roles below your own, and give them to people.",
  "perm.manage_members": "Manage members",
  "perm.manage_members.hint": "Change other members’ nicknames, remove members and clean up inactive ones. Everyone can change their own nickname.",
  "perm.kick_members": "Kick people",
  "perm.kick_members.hint": "Disconnect people from the server. They can come back.",
  "perm.ban_members": "Ban people",
  "perm.ban_members.hint": "Keep people out for a while or for good, and lift bans.",
  "perm.create_invites": "Invite people",
  "perm.create_invites.hint": "Create invite links and one-time tokens, for roles below your own.",
  "perm.bypass_password": "Enter password channels",
  "perm.bypass_password.hint": "Join and read channels that have a password without knowing it.",
  "perm.attach_files": "Share files",
  "perm.attach_files.hint": "Attach images and files to messages.",
  "perm.manage_messages": "Delete others' messages",
  "perm.manage_messages.hint": "Remove messages written by other people.",
  "perm.move_members": "Move people",
  "perm.move_members.hint": "Drag people into other channels.",
  "perm.manage_channels": "Manage channels",
  "perm.manage_channels.hint": "Create, edit, move and delete channels.",
  "ss.rolesOrderHint": "Higher roles rank above lower ones. Drag to reorder the roles below yours.",
  "ss.yourRank": "your rank",
  "ss.moveUp": "Move up",
  "ss.moveDown": "Move down",
  "ss.roleDisplay": "Display",
  "ss.roleHoist": "Show members separately",
  "ss.roleHoistHint": "Online members with this role get their own group in the member list.",
  "ss.roleMentionable": "Allow @mentions",
  "ss.roleMentionableHint": "Anyone can notify everyone with this role by writing @role.",

  "settings.account": "Account",
  "account.intro":
    "Gwar Connect is an optional account that keeps one identity on all your devices. It never sees your password or your key: the key is stored encrypted, and only your password or recovery code can open it.",
  "account.signInTitle": "Sign in",
  "account.createTitle": "Create an account",
  "account.recoverTitle": "Recover with code",
  "account.handle": "Handle",
  "account.handleHint": "3 to 32 characters: a-z, 0-9, _ and .",
  "account.handleInvalid": "A handle is 3 to 32 characters: a-z, 0-9, _ and . (not at the start or end).",
  "account.password": "Password",
  "account.currentPassword": "Current password",
  "account.newPassword": "New password",
  "account.passwordConfirm": "Repeat the password",
  "account.passwordShort": "Use at least {min} characters.",
  "account.passwordMismatch": "The passwords don't match.",
  "account.strength.weak": "Weak password",
  "account.strength.fair": "Fair password",
  "account.strength.strong": "Strong password",
  "account.identityChoice": "Which identity should the account use?",
  "account.keep": "Keep my current identity",
  "account.keepHint": "Your roles on servers stay with you. Any identity backup you exported before this remains a full account credential, even after this device is revoked.",
  "account.fresh": "Start fresh",
  "account.freshHint": "A new identity without roles. The current one stays on this device and comes back when you sign out.",
  "account.create": "Create account",
  "account.signIn": "Sign in",
  "account.recover": "Recover account",
  "account.forgot": "Forgot your password? Recover with a code",
  "account.haveAccount": "Already have an account? Sign in",
  "account.noAccount": "New here? Create an account",
  "account.back": "Back",
  "account.recoveryTitle": "Save your recovery code",
  "account.recoveryBody":
    "This code is the only way back into your account if you forget the password. It is shown once. Keep it somewhere safe, for example in a password manager.",
  "account.recoveryCode": "Recovery code",
  "account.recoveryCodeHint": "Case, spaces and dashes don't matter.",
  "account.recoveryDownload": "Download",
  "account.recoverySaved": "I saved my recovery code",
  "account.recoverySavedNew": "I saved the new recovery code",
  "account.recoveryChange": "Change recovery code",
  "account.recoveryChangeHint": "Shows a new code first; the old one stops working once you confirm with your password.",
  "account.recoveryChanged": "Recovery code changed. The old one no longer works.",
  "account.recoveryContinue": "Continue",
  "account.recoveryCreating": "The account @{handle} is created when you press Continue. Nothing has been sent yet.",
  "account.recoveryHandle": "Pick another handle. Your recovery code stays the same.",
  "account.signedIn": "Signed in as @{handle}. Reconnect to your servers to use it.",
  "account.signedOut": "Signed out. Your local identity is back.",
  "account.signedInAs": "Signed in as @{handle}",
  "account.connectEntry": "Sign in with Gwar Connect",
  "account.connectEntryHint": "Keep one identity on all your devices.",
  "account.accountKey": "Account key",
  "account.thisDevice": "This device",
  "account.devices": "Devices",
  "account.devicesHint": "Names and activity are reported by Connect; this list may be incomplete. Device keys identify the devices.",
  "account.archive": "Message key backup",
  "account.archiveUploads": "Back up message keys to Gwar Connect",
  "account.archiveUploadsHint": "Encrypted keys of your conversations are kept in Gwar Connect, so your other devices and your recovery code can open their history. Connect cannot read them. Off: this device uploads nothing, but still reads the backup.",
  "account.devicesFailed": "Could not load the devices.",
  "account.refresh": "Refresh",
  "account.revoked": "Revoked",
  "account.lastSeen": "Last seen {when}",
  "account.revoke": "Revoke",
  "account.revokeTitle": "Revoke {name}",
  "account.revokeBody": "Enter your password to revoke this device. It can no longer act as you on servers; they notice within a few minutes.",
  "account.deviceRevoked": "Device revoked.",
  "account.thisRevoked": "This device was revoked. Sign out and sign in again to use the account.",
  "account.certificate": "Sign-in on this device",
  "account.certExpires": "You’re signed in on this device until {date}.",
  "account.renew": "Sign in again",
  "account.renewTitle": "Sign in again on this device",
  "account.renewBody": "Enter your Gwar Connect password to keep using your account on this device.",
  "account.renewed": "You’re signed in again on this device.",
  "account.renewWithPassword": "Sign in again",
  "account.certExpiringWarn": "Enter your password again by {date} to keep connecting on this device.",
  "account.certExpiredWarn": "Enter your password again to connect on this device. Your name and roles are safe.",
  "account.changePassword": "Change password",
  "account.passwordChanged": "Password changed. Your other sessions were signed out.",
  "account.signOut": "Sign out",
  "account.signOutHint": "You go back to the identity stored on this device (user ID {uid}). The account stays in Gwar Connect.",
  "account.confirm": "Confirm",
  "account.err.network": "Can't reach Gwar Connect. Check your connection and try again.",
  "account.err.password": "Wrong handle or password.",
  "account.err.passwordOnly": "Wrong password.",
  "account.err.code": "Wrong handle or recovery code.",
  "account.err.rate": "Too many attempts. Try again in a few minutes.",
  "account.err.taken": "This handle is taken, or this identity already has an account.",
  "account.err.revoked": "This device was revoked.",
  "account.err.session": "Your session ended. Renew the certificate (with your password) to refresh it.",
  "account.err.other": "Gwar Connect failed: {message}",
  "identity.connectNote":
    "You are signed in with Gwar Connect as @{handle}. Your identity belongs to the account and is the same on every device. Manage it in the Account tab.",
  "identity.accountKey": "Account key",
  "ts.title": "TeamSpeak identities",
  "ts.introAccount":
    "While you are signed in, TeamSpeak servers know you by your account's TeamSpeak identities, the same on all your desktop apps. They are stored encrypted in Gwar Connect.",
  "ts.introDevice":
    "TeamSpeak servers know you by one of these identities. Sign in with Gwar Connect to use the same ones on all your desktop apps.",
  "ts.empty": "No identities yet. One is made when you first connect to a TeamSpeak server.",
  "ts.listLabel": "TeamSpeak identities",
  "ts.default": "Default",
  "ts.level": "Security level {level}",
  "ts.copyUid": "Copy unique ID",
  "ts.rename": "Rename",
  "ts.setDefault": "Make default",
  "ts.export": "Export for TeamSpeak client",
  "ts.delete": "Delete",
  "ts.add": "Add",
  "ts.import": "Import from TeamSpeak client…",
  "ts.generate": "Generate new…",
  "ts.find": "Find on this computer…",
  "ts.name": "Name",
  "ts.unnamed": "Identity {n}",
  "ts.added": "TeamSpeak identity added.",
  "ts.alreadyListed": "That identity is already in the list.",
  "ts.changeFailed": "Could not change the identities: {message}",
  "ts.importTitle": "Import a TeamSpeak identity",
  "ts.importBody":
    "Paste the identity string, or the contents of an identity .ini file exported by the TeamSpeak client (TeamSpeak 3: Tools, Identities, Export; TeamSpeak 6: right-click the identity, Export).",
  "ts.importField": "Identity",
  "ts.importFile": "Choose a file…",
  "ts.importFailed": "Could not add the identity: {message}",
  "ts.generateTitle": "Generate a new identity",
  "ts.generateBody": "A new TeamSpeak identity is made on this device. TeamSpeak servers see it as a new person until they give it groups.",
  "ts.generateAction": "Generate",
  "ts.findTitle": "TeamSpeak identities on this computer",
  "ts.findBody": "These identities are stored by the official TeamSpeak client on this computer. Choose the ones to use here.",
  "ts.findSearching": "Looking…",
  "ts.findError": "Could not look: {message}",
  "ts.findNone":
    "No TeamSpeak identity found. In the TeamSpeak client, export an identity to an .ini file (TeamSpeak 3: Tools, Identities, Export; TeamSpeak 6: right-click the identity, Export), then use “Import from TeamSpeak client” here. The .ini files of both versions work.",
  "ts.findImport": "Import selected",
  "ts.findLastUsed": "last used",
  "ts.findLow": "Security level {level}, but servers need at least {min}. Raise it in the TeamSpeak client first.",
  "ts.findHave": "Already added",
  "ts.findAdded": "Imported identities: {count}",
  "ts.firstTitle": "Use your TeamSpeak identity?",
  "ts.firstBody":
    "The TeamSpeak client on this computer has identities. Use one here and TeamSpeak servers will recognize you and keep your groups. Or create a new one.",
  "ts.firstUse": "Use selected",
  "ts.firstNew": "Create a new one instead",
  "ts.renameTitle": "Rename identity",
  "ts.deleteTitle": "Delete “{name}”?",
  "ts.deleteBodyAccount":
    "This removes the identity from your account, on every device. Server groups and permissions that depend on it are lost unless you exported it first.",
  "ts.deleteBodyDevice":
    "This removes the identity from this device. Server groups and permissions that depend on it are lost unless you exported it first.",
  "ts.deleteAction": "Delete identity",
  "ts.deleted": "Identity deleted.",
  "ts.exportTitle": "Export “{name}” for the TeamSpeak client",
  "ts.exportBody": "In the TeamSpeak client, import this string (Tools, Identities, Import) to use the same identity there.",
  "ts.exportWarning": "This is a secret key. Whoever has it can pretend to be you on TeamSpeak servers. Don't share it.",
  "ts.webLabel": "These TeamSpeak identities are used by your desktop apps.",
  "ts.webNone": "No TeamSpeak identities yet. The first desktop app you sign in on stores its own here.",
  "ts.loadFailed": "Could not load the TeamSpeak identities: {message}",
  "ts.pickerDefault": "{name} (default)",
  "tsClaim.title": "Roles from TeamSpeak",
  "tsClaim.body":
    "This server moved from TeamSpeak, and these TeamSpeak identities of yours have roles here. Bring the roles to your Gwar account? Joining with these identities on TeamSpeak then counts as you, and others on this server can see that they are yours.",
  "tsClaim.accept": "Claim the roles",
  "tsClaim.later": "Not now",
  "tsClaim.done": "Your roles from TeamSpeak are now on your account here.",
  "tsClaim.failed": "Some TeamSpeak identities could not be claimed.",
  "tsClaim.linked": "TeamSpeak identities",
  "tsClaim.unlink": "Unlink",
  "tsClaim.unlinkConfirm": "Unlink this TeamSpeak identity? The roles stay; joining with it on TeamSpeak no longer counts as this member.",
  "tsClaim.unlinked": "TeamSpeak identity unlinked.",
  "tsClaim.check": "Claim roles from TeamSpeak",
  "tsClaim.codes": "Your account here: {account}… · this server: {server}…. Gwar's own question for each identity shows the same codes.",
  "tsClaim.none": "None of your TeamSpeak identities has roles here.",

  "close.removed": "You were removed from the server by {by}. You can join again as a new member.",
  "mod.remove": "Remove member…",
  "mod.removeNamed": "Remove {name}",
  "mod.removeTitle": "Remove {name}?",
  "mod.removeBody": "Their record is deleted, with their roles and read marks. This is not a ban: they can join again as a new member.",
  "mod.removeMessages": "Also delete their messages and files",
  "mod.removeMessagesHint": "Without this their messages stay, still showing their name.",
  "mod.removeNote": "They need the server password or an invite to come back, like anyone new.",
  "mod.removeNoteOnline": "They are online and are disconnected now. They need the server password or an invite to come back, like anyone new.",
  "mod.removed": "{name} was removed.",
  "ss.cleanup": "Clean up",
  "ss.cleanupIntro": "Remove people who haven't been here for a while. This is not a ban: they can join again as new members.",
  "ss.pruneDays": "Not seen for (days)",
  "ss.pruneDaysHint": "From 1 to {max} days.",
  "ss.pruneDaysInvalid": "Enter a whole number of days from 1 to {max}.",
  "ss.pruneKeepRoles": "Keep members who have roles",
  "ss.pruneKeepRolesHint": "Administrators, moderators and anyone with a role besides Member stay.",
  "ss.pruneMessages": "Also delete their messages and files",
  "ss.pruneMessagesHint": "Without this their messages stay, still showing their name.",
  "ss.pruneAlwaysKept": "People who are online, you, and anyone with permissions you don't have are always kept.",
  "ss.prunePreview": "Preview",
  "ss.pruneRemoveIdle": "Remove",
  "ss.pruneRunning": "Removing… {done} of {total}",
  "ss.pruneListLabel": "Members to remove",
  "ss.pruneNone": "Nobody matches. Nothing to remove.",
  "ss.pruneMore": "…and {count} more",
  "ss.pruneFound.one": "{count} member would be removed",
  "ss.pruneFound.other": "{count} members would be removed",
  "ss.pruneFound.few": "{count} members would be removed",
  "ss.pruneFound.many": "{count} members would be removed",
  "ss.pruneRemove.one": "Remove {count} member",
  "ss.pruneRemove.other": "Remove {count} members",
  "ss.pruneRemove.few": "Remove {count} members",
  "ss.pruneRemove.many": "Remove {count} members",
  "ss.pruneDone.one": "{count} member was removed.",
  "ss.pruneDone.other": "{count} members were removed.",
  "ss.pruneDone.few": "{count} members were removed.",
  "ss.pruneDone.many": "{count} members were removed.",
  "common.advanced": "Advanced",
  "common.details": "Details",
  "onboarding.title": "What should people call you?",
  "onboarding.hint": "Choose a name your friends will recognize. You can change it later.",
  "onboarding.name": "Your name",
  "onboarding.continue": "Continue",
  "onboarding.skip": "Skip for now",
  "connect.publicServer": "Join the public server (gwar.app)",
  "identity.keepIdentity": "Protect your identity — without a backup, clearing browser data will erase your name and roles.",
  "identity.keepIdentityDesktop": "Protect your identity — without a backup, removing Gwar’s data will erase your name and roles.",
  "identity.protectTitle": "Protect your identity",
  "identity.protect": "Protect",
  "identity.lossWarning": "If you clear browser data, you’ll lose your name and roles.",
  "identity.lossWarningDesktop": "If you remove Gwar’s data from this computer, you’ll lose your name and roles.",
  "identity.createConnectAccount": "Create a Gwar Connect account",
  "identity.createAccount": "Create an account",
  "identity.exportBackup": "Save a backup",
  "identity.exportFailed": "Couldn’t export your backup. Please try again.",
  "account.signInAgain": "Sign in again",
  "account.signInShort": "Sign in",
  "account.signInExpiredShort": "Sign-in expired",
  "account.signInDaysShort.one": "Sign in within {count} day",
  "account.signInDaysShort.few": "Sign in within {count} days",
  "account.signInDaysShort.many": "Sign in within {count} days",
  "account.signInDaysShort.other": "Sign in within {count} days",
  "account.signInExpired": "Enter your password again on this device to connect to servers. Your name and roles are safe.",
  "account.signInDays.one": "In {count} day you’ll need to enter your password again on this device.",
  "account.signInDays.few": "In {count} days you’ll need to enter your password again on this device.",
  "account.signInDays.many": "In {count} days you’ll need to enter your password again on this device.",
  "account.signInDays.other": "In {count} days you’ll need to enter your password again on this device.",
  "server.connected": "Connected",
  "screen.qualityGood": "Good quality",
  "err.channel.save": "Couldn’t save the channel. Check its settings and try again.",
  "common.loading": "Loading…",
  "screen.shareAgain": "Share again",
  "voice.channelRemoved": "The voice channel was removed. Join another channel to talk.",
  "voice.disconnected": "Voice disconnected.",
  "voice.reconnectFailed": "Couldn’t reconnect voice.",
  "identity.backupSecret": "This file contains your private key. Keep it secret — anyone with it can impersonate you.",
  "audio.pttModeHint": "Hold your chosen key to talk.",
  "audio.noiseSuggestion": "Enable noise suppression for background noise.",
  "audio.manualUnsupported": "Manual sensitivity needs a newer server.",
  "audio.pttUnsupported": "Push-to-talk needs a newer server.",
  "err.voice.input_mode_unsupported": "This server does not support push-to-talk. Choose voice activation.",
} as const;

export type Key = keyof typeof en;
